<main>
  <mat-toolbar
    class="mat-elevation-z8 nav-bar"
    [ngClass]="{ 'dark-nav-bar': darkNavBar() }"
  >
    <mat-toolbar-row class="shadow">
      @if (!successScreenRoute()) {
        <img
          [src]="getLogo()"
          alt="Logo"
          class="logo"
          (click)="navigateHome()"
        />
      } @else {
        <img [src]="getLogo()" alt="Logo" class="reviews-logo" />
      }
      @if (!successScreenRoute()) {
        <article
          [ngClass]="{
            'menu-content': (isLoggedIn$ | async),
            'not-loggedIn': !(isLoggedIn$ | async)
          }"
        >
          @if ((isLoggedIn$ | async) && (isHod$ | async)) {
            <section
              [ngClass]="{
                'white-nav-button': !darkNavBar() && !successScreenRoute(),
                'button-container': darkNavBar() && !successScreenRoute()
              }"
            >
              @if (enableRenewApplication()) {
                <a class="button" [matMenuTriggerFor]="appMenu">
                  New application
                </a>
                <p class="bursary-funds-arrow-container">
                  <mat-icon class="bursary-funds-arrow"> expand_more </mat-icon>
                </p>
                <mat-menu #appMenu="matMenu">
                  <button mat-menu-item routerLink="/student/application">
                    Create new application
                  </button>
                  <button
                    mat-menu-item
                    routerLink="/Renew"
                    (click)="navigateToRenewApplication()"
                  >
                    Renew application
                  </button>
                </mat-menu>
              } @else {
                <a class="button" routerLink="/student/application">
                  New application
                </a>
              }
            </section>
            <section class="mat-menu">
              <app-shared-menu
                [label]="'Bursaries & applications'"
              ></app-shared-menu>
            </section>
          }
          @if (isDean$ | async) {
            <ng-container class="nav-container">
              <section
                [ngClass]="{
                  'white-nav-button': !darkNavBar(),
                  'button-container': darkNavBar()
                }"
              >
                <app-shared-menu
                  [label]="'My departments'"
                  [userDetails]="userDetails"
                ></app-shared-menu>
                <section class="mat-menu">
                  <a
                    routerLink="/dashboard"
                    (click)="navigate('/dashboard/profiles')"
                    class="button"
                    >Profile management</a
                  >
                  <a
                    routerLink="/"
                    class="button"
                    (click)="navigate('/dashboard/funds')"
                    >My funding</a
                  >
                </section>
              </section>
            </ng-container>
          }
          @if ((isLoggedIn$ | async) && (isStudent$ | async)) {
            <ng-container class="nav-container">
              <section
                [ngClass]="{
                  'white-nav-button': !darkNavBar(),
                  'button-container': darkNavBar()
                }"
              >
                <a routerLink="/student/bursaryInformation" class="button"
                  >Bursary Information</a
                >
                <a routerLink="/student/details" class="button">Details</a>
                <a routerLink="/student/documents" class="button">Documents</a>
                <a routerLink="/student/events" class="button">Events</a>
              </section>
            </ng-container>
          }
          @if (isOverviewer$ | async) {
            <ng-container class="nav-container">
              <section
                [ngClass]="{
                  'white-nav-button': !darkNavBar(),
                  'button-container': darkNavBar()
                }"
              >
                <app-shared-menu
                  [label]="'Ukukhula Bursary Fund'"
                ></app-shared-menu>
                <section class="mat-menu">
                  <a routerLink="/admin/fundAllocations">Fund allocations</a>
                </section>
              </section>
            </ng-container>
          }
          <section
            class="funds-menu-container"
            [ngClass]="{
              'button-container':
                darkNavBar() &&
                !successScreenRoute() &&
                !url.includes('upload-transcript'),
              'white-nav-button': !darkNavBar() && !successScreenRoute()
            }"
          >
            @if (
              (isLoggedIn$ | async) &&
              !successScreenRoute() &&
              !url.includes("upload-transcript")
            ) {
              <a (click)="logout()"> Log out </a>
            }
            @if (
              !(isLoggedIn$ | async) &&
              !successScreenRoute() &&
              !url.includes("upload-transcript")
            ) {
              <a (click)="login()"> Login </a>
            }
          </section>
        </article>
      }
      @if (!url.includes("upload-transcript")) {
        <button mat-icon-button class="menu-icon" [matMenuTriggerFor]="menu">
          @if (!successScreenRoute() && !url.includes("upload-transcript")) {
            <mat-icon>menu</mat-icon>
          }
        </button>
      }
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-menu #menu="matMenu" class="mobile-menu" color="primary">
    @if (
      (isLoggedIn$ | async) &&
      !successScreenRoute() &&
      !url.includes("upload-transcript")
    ) {
      <section>
        <button mat-menu-item routerLink="/">
          <mat-icon>home</mat-icon>
          <a mat-button>Home</a>
        </button>
        @if ((isLoggedIn$ | async) && (isHod$ | async)) {
          <button mat-menu-item routerLink="/student/application">
            <mat-icon>create</mat-icon>
            <a mat-button>Create new application</a>
          </button>
          <button mat-menu-item routerLink="/student/application/renew">
            <mat-icon>autorenew</mat-icon>
            <a mat-button>Renew application</a>
          </button>
          <button mat-menu-item routerLink="/dashboard/bursaries">
            <mat-icon>business_center</mat-icon>
            <a mat-button>My bursaries</a>
          </button>
        }
        @if ((isLoggedIn$ | async) && (isDean$ | async)) {
          <button mat-menu-item [matMenuTriggerFor]="departmentsMenu">
            <mat-icon>dashboard</mat-icon>
            <span>My Department</span>
          </button>
          <mat-menu
            #departmentsMenu="matMenu"
            [overlapTrigger]="false"
            xPosition="before"
            yPosition="above"
          >
            @for (department of menuItems; track department) {
              <section>
                <button
                  mat-menu-item
                  routerLink="/dean"
                  (click)="
                    navigate(
                      '/dashboard/departments' +
                        department.universityDepartmentName
                    )
                  "
                >
                  {{ department.universityDepartmentName }}
                </button>
              </section>
            }
          </mat-menu>
          <button
            mat-menu-item
            routerLink="/dean"
            (click)="navigate('/dashboard/profiles')"
          >
            <mat-icon>person</mat-icon>
            <a mat-button>Profile management</a>
          </button>
          <button
            mat-menu-item
            routerLink="/dean"
            (click)="navigate('/dashboard/funds')"
          >
            <mat-icon>account_balance_wallet</mat-icon>
            <a mat-button>My funding</a>
          </button>
        }
        @if ((isLoggedIn$ | async) && (isStudent$ | async)) {
          <button mat-menu-item routerLink="/student/bursaryInformation">
            <mat-icon>business_center</mat-icon>
            <a mat-button>Bursary Information</a>
          </button>
          <button mat-menu-item routerLink="/student/details">
            <mat-icon>person</mat-icon>
            <a mat-button>Details</a>
          </button>
          <button mat-menu-item routerLink="/student/documents">
            <mat-icon>insert_drive_file</mat-icon>
            <a mat-button>Documents</a>
          </button>
          <button mat-menu-item routerLink="/student/events">
            <mat-icon>event</mat-icon>
            <a mat-button>Events</a>
          </button>
        }
        @if (!(isLoggedIn$ | async)) {
          <button mat-menu-item (click)="login()">
            <mat-icon>login</mat-icon>
            <a mat-button>Login</a>
          </button>
        }
      </section>
    }
    @if ((isLoggedIn$ | async) && !successScreenRoute()) {
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <a mat-button>Log out</a>
      </button>
    }
    @if (!(isLoggedIn$ | async)) {
      <button mat-menu-item (click)="login()">
        <mat-icon>login</mat-icon>
        <a mat-button>Login</a>
      </button>
    }
  </mat-menu>
  <section class="main-content">
    <router-outlet></router-outlet>
  </section>
</main>
<app-loader></app-loader>
